import en from '../../assets/localization/en.json';
import enSocial from '../../assets/localization/en-social.json';
import SoundManager from 'Engine/soundManager/SoundManager';
import { eSounds } from '../enums/eSounds';

export default {
  onButtonClick: onWrapperButtonClick,
  bundle: 'happycookie',
  localizationBundle: 'happycookie',
  localizations: { en, 'en-social': enSocial },
  lang: 'en',
  fallbackLang: 'en'
};

function onWrapperButtonClick() {
  SoundManager.play(eSounds.EST_BUTTON_CLICK.soundName, eSounds.EST_BUTTON_CLICK.volume, false, eSounds.EST_BUTTON_CLICK.group);
}
